export default __webpack_public_path__ + "static/media/МП-20.30be781a.png";